<template>
  <div class="store" :class="{ expired }">
    <div class="store-eyebrow">Storage</div>
    <div class="store-head">
      <span class="store-amt">{{ head }}</span>
      <span class="store-pill">{{ pill }}</span>
    </div>
    <div class="store-bar"><span class="store-fill" :style="{ width: pct + '%' }"></span></div>
    <p class="store-note">{{ note }}</p>
    <a class="btn btn-gold store-cta" :href="storage.upgradeUrl || '#'" target="_blank" rel="noopener">{{ cta }}</a>
  </div>
</template>

<script>
import { fmtDateShort } from '../useEvent';

const DAY = 864e5;

export default {
  name: 'StorageUpsell',
  props: {
    storage: { type: Object, required: true },
    eventId: { type: String, required: true },
  },
  data() {
    return { now: Date.now(), start: 0, hasAnchor: true };
  },
  computed: {
    label() {
      return this.storage.label || '';
    },
    freeDays() {
      return this.storage.freeDays || 7;
    },
    expiry() {
      return this.start + this.freeDays * DAY;
    },
    daysLeft() {
      return Math.ceil((this.expiry - this.now) / DAY);
    },
    expired() {
      return this.daysLeft <= 0;
    },
    pct() {
      return Math.max(0, Math.min(100, ((this.now - this.start) / (this.freeDays * DAY)) * 100)).toFixed(0);
    },
    expiryDate() {
      return fmtDateShort(this.expiry);
    },
    head() {
      return `${this.label} · ${this.expired ? 'preview quality' : 'held in full quality'}`;
    },
    pill() {
      if (this.expired) return 'Full-quality window ended';
      return `${this.daysLeft} ${this.daysLeft === 1 ? 'day' : 'days'} left`;
    },
    cta() {
      return this.expired ? 'Restore full quality →' : 'Keep it in full quality →';
    },
    note() {
      if (this.expired) {
        return 'This archive is now served at preview quality. Restore full quality anytime: every camera, every clip and the complete recording.';
      }
      if (!this.hasAnchor) {
        return `Kept in full quality for ${this.freeDays} days from your first view. After that this archive downscales to preview quality to save space.`;
      }
      return `Kept in full quality for ${this.freeDays} days from your first view, through ${this.expiryDate}. After that this archive downscales to preview quality to save space.`;
    },
  },
  created() {
    // countdown anchored to the viewer's first visit (per event)
    const key = `decast_free_start_${this.eventId}`;
    try {
      let start = parseInt(localStorage.getItem(key), 10);
      if (!start) {
        start = Date.now();
        localStorage.setItem(key, String(start));
      }
      this.start = start;
    } catch (e) {
      this.hasAnchor = false;
      this.start = Date.now();
    }
  },
};
</script>
